
































import { Component, Vue, Prop } from 'vue-property-decorator'
import { gotoDetail, getDateTime } from '@core/utils/index'

@Component({})
export default class PromotionSeckillItem extends Vue {
  @Prop({ default: 0 }) readonly serviceTime!: number
  @Prop({ default: () => {} }) readonly seckill!: any

  isEnd = false

  toDetail() {
    const { businessId, templateType2Id: spuType, spuId = '', skuId = '', promotionId: ruleId = '', promotionType: ruleType = '' } = this.seckill
    gotoDetail({ businessId, spuType, spuId, skuId, ruleId, ruleType,module: 6 })
  }

  money(price: number) {
    const _price = (price / 100).toFixed(1)
    let splitPrice = _price.toString().split('.')
    return `${splitPrice[0]}.<span style="font-size:0.24rem;">${splitPrice[1]}</span>`
  }

  showTime(endtime: string) {
    let _end = parseInt(getDateTime(endtime))
    return this.timeDown(_end)
  }

  timeDown(_end: number) {
    let that = this
    const endDate = _end
    const nowTime = this.serviceTime
    const left = parseInt(((endDate - nowTime) / 1000).toString())

    let day: string | number = 0,
      hour: string | number = 0,
      minute: string | number = 0,
      second: string | number = 0
    if (left > 0) {
      setTimeout(function() {
        that.seckill.promotionEndTime = _end - 1000
      }, 1000)
      day = Math.floor(left / (60 * 60 * 24))
      hour = Math.floor(left / (60 * 60)) - day * 24
      minute = Math.floor(left / 60) - day * 24 * 60 - hour * 60
      second = Math.floor(left) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
      if (day <= 9) {
        day = `0${day}`
      }
      if (hour <= 9) {
        hour = `0${hour}`
      }
      if (minute <= 9) {
        minute = `0${minute}`
      }
      if (second <= 9) {
        second = `0${second}`
      }
      return `${day}天 ${hour}时 ${minute}分`
    }
    if (left <= 0) {
      that.isEnd = true
      return `00天 00时 00分`
    }
  }
}
